import { Action } from '../../../../shared/xs/actions';

export class StartImpactScanAction implements Action {
  static readonly type = '[Impact Scan Revamp] Start impact scan';
}
